import React from 'react';
import {Redirect} from 'react-router';
import {CustomRouteConfig} from 'frontend-core/build/components/sidebar/sidebar';
import {AppState} from './containers/App';

import Main from './components/main/main';

export const createRoutes = (routes: any[], user: AppState['user']): CustomRouteConfig[] | any => {
  return [
    {
      component: (props: any) => <Main {...props} user={user} />,
      label: 'Main',
      path: '',
      routes:
        routes.length > 0
          ? [
              {
                component: () => <Redirect to={routes[0].path} />,
                exact: true,
                hidden: true,
                path: '/'
              },
              ...routes
            ]
          : []
    }
  ];
};
